import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle1" }, " Please input the login code we emailed to you: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_resend_code_btn = _resolveComponent("resend-code-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
  }, [
    _createVNode(_component_q_card_section, null, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_q_input, {
          label: "Code",
          "input-mode": "numeric",
          modelValue: _ctx.pin,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pin) = $event)),
          outlined: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_async_btn, {
          type: "submit",
          task: _ctx.task,
          label: "Login",
          color: "primary",
          class: "full-width q-mt-lg"
        }, null, 8, ["task"]),
        _createVNode(_component_q_separator, { class: "q-my-md" }),
        _createVNode(_component_resend_code_btn, {
          email: _ctx.command.email,
          password: _ctx.command.password
        }, null, 8, ["email", "password"])
      ]),
      _: 1
    })
  ], 32))
}